import type { SocialPlatform } from "@content-os/config";

const FILE: Partial<Record<SocialPlatform, string>> = {
  INSTAGRAM: "instagram",
  TIKTOK: "tiktok",
  FACEBOOK: "facebook",
  YOUTUBE: "youtube",
  LINKEDIN: "linkedin",
  TWITTER: "x",
  THREADS: "threads",
  PINTEREST: "pinterest",
  REDDIT: "reddit",
  GOOGLEBUSINESS: "google-business",
};

interface Props {
  platform: SocialPlatform;
  size?: number;
  className?: string;
}

export function PlatformIcon({ platform, size = 32, className }: Props) {
  const file = FILE[platform];
  if (!file) return null;
  return (
    <img
      src={`/icons/${file}.svg`}
      alt={platform}
      width={size}
      height={size}
      className={className}
      loading="lazy"
    />
  );
}
